module.exports = __webpack_public_path__ + "img/sm.e03072bc.svg";